module.exports = __webpack_public_path__ + "img/second_zhCn.3f877480.png";